import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import styles from "./RadioButtons.module.scss";
import { RadioButton } from "./RadioButton";
import AnimateHeight from "react-animate-height";
export const RadioButtonGroup: React.FC<{
  options: {
    title: string;
    value: number;
    data_cy?: string;
    data_id?: string;
    disabled?: boolean;
    content?: any;
  }[];
  selected: number | undefined;
  onSelect: (value: number) => void;
}> = t0 => {
  const $ = _c(18);
  const {
    options,
    selected,
    onSelect
  } = t0;
  let t1;
  if ($[0] !== options) {
    t1 = options.map(_temp).join("_");
    $[0] = options;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [name] = useState(`radio-button-group-${t1}`);
  let t2;
  if ($[2] !== options) {
    t2 = options.some(_temp2);
    $[2] = options;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const optionHasContent = t2;
  let wrapperClasses;
  if ($[4] !== optionHasContent) {
    wrapperClasses = [styles.radiobuttongroup];
    if (optionHasContent) {
      wrapperClasses.push(styles.radiobuttongroup__withcontent);
    }
    $[4] = optionHasContent;
    $[5] = wrapperClasses;
  } else {
    wrapperClasses = $[5];
  }
  const t3 = wrapperClasses.join(" ");
  let t4;
  if ($[6] !== name || $[7] !== onSelect || $[8] !== options || $[9] !== selected) {
    let t5;
    if ($[11] !== name || $[12] !== onSelect || $[13] !== selected) {
      t5 = option_0 => <div key={option_0.value}><RadioButton data_cy={option_0.data_cy ? option_0.data_cy : ""} dataId={option_0.data_id} name={name} title={option_0.title} selected={selected === option_0.value} disabled={option_0.disabled} onSelect={() => onSelect(option_0.value)} />{option_0.content && <AnimateHeight height={selected === option_0.value ? "auto" : 0} animateOpacity={true} duration={300}><div className={styles.radiobuttongroup__content}>{option_0.content}</div></AnimateHeight>}</div>;
      $[11] = name;
      $[12] = onSelect;
      $[13] = selected;
      $[14] = t5;
    } else {
      t5 = $[14];
    }
    t4 = options.map(t5);
    $[6] = name;
    $[7] = onSelect;
    $[8] = options;
    $[9] = selected;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[15] !== t3 || $[16] !== t4) {
    t5 = <div className={t3}>{t4}</div>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
};
function _temp(o) {
  return (o.title || "").toLowerCase().trim().split(" ").join();
}
function _temp2(option) {
  return option.content;
}